import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Stock from '@/view/record/stock/Stock'

export default {
  path: '/stock',
  name: 'Stock',
  components: {
    default: Stock,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record-user',
    breadcrumb: [
      { name: 'Cadastro', link: '/record' },
      { name: 'Estoque' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/record/StockRoute.js